
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us/[url_slug]",
      function () {
        return require("private-next-pages/contact-us/[url_slug]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-us/[url_slug]"])
      });
    }
  